import React from 'react';
import { Camera, X, Check } from 'lucide-react';

// One labelled, required photo slot (e.g. "Front", "Signature") for the consign form.
const PhotoSlot = ({ id, label, hint, file, onChange }) => (
  <div className="flex flex-col" data-testid={`consign-slot-${id}`}>
    <div className={`relative aspect-square rounded-lg border-2 ${file ? 'border-black' : 'border-dashed border-neutral-300'} overflow-hidden`}>
      {file ? (
        <>
          <img src={URL.createObjectURL(file)} alt={label} className="w-full h-full object-cover" />
          <button
            type="button"
            onClick={() => onChange(null)}
            className="absolute top-2 right-2 w-8 h-8 bg-black/80 text-white rounded-full flex items-center justify-center hover:bg-black"
            aria-label={`Remove ${label} photo`}
            data-testid={`consign-slot-${id}-remove`}
          >
            <X className="w-4 h-4" />
          </button>
        </>
      ) : (
        <label htmlFor={`slot-${id}`} className="absolute inset-0 flex flex-col items-center justify-center cursor-pointer hover:bg-neutral-50 transition-colors p-3 text-center">
          <Camera className="w-8 h-8 mb-2 text-neutral-400" />
          <span className="text-sm">Add photo</span>
          <span className="text-[11px] text-neutral-500 mt-1">{hint}</span>
        </label>
      )}
      <input
        id={`slot-${id}`}
        type="file"
        accept="image/*"
        capture="environment"
        className="hidden"
        onChange={(e) => { if (e.target.files?.[0]) onChange(e.target.files[0]); e.target.value = ''; }}
        data-testid={`consign-slot-${id}-input`}
      />
    </div>
    <span className="mt-2 text-xs uppercase tracking-wider flex items-center gap-1">
      {file && <Check className="w-3.5 h-3.5" />}{label} <span className="text-red-600">*</span>
    </span>
  </div>
);

export default PhotoSlot;
